"use strict";

import PrimerMaster from "/js/util/primermaster.js";
import Global from "/js/core/global.js";
import AppUtil from "/js/util/app-util.js";
import Autoshrink from "/js/util/autoshrink.js";
import CardView from "/js/card-views/card-view.js";

/**
 * Lesson interaction card. Displays an optional image and caption, a block of text, and a CTA
 * button at the bottom.
 */
export default class InteractionCardView extends CardView {

  static _FULL_TEMPLATE_STRING = "\
      <img class='img' src='<%= image %>' alt=''>\
      <div class='caption'><%= caption %></div>\
      <div class='text'><%= text %></div>\
      <div class='button <%= buttonBgClass %>'><%= buttonLabel %></div>\
      <div class='dot'></div>";
  static _fullTemplate = _.template(InteractionCardView._FULL_TEMPLATE_STRING);

  static _TEXT_ONLY_TEMPLATE_STRING = `
      <div class='text-only'><%= text %></div>
      <div class='button <%= buttonBgClass %>'><%= buttonLabel %></div>
      <div class='dot'></div>`;
  static _textOnlyTemplate = _.template(InteractionCardView._TEXT_ONLY_TEMPLATE_STRING);

  makeContent() {
    const o = {};
    o.text = CardView.makeHtmlFromJsonTextArray(this.data);
    o.buttonLabel = this.data.interactionLabel;
    o.buttonBgClass = PrimerMaster.getBgDarkColorClassForLessonId(Global.lessonId);

    const hasImage = (this.data.image && this.data.image.url && this.data.image.caption);
    if (hasImage) {
      o.image = AppUtil.makeLessonAssetPath(this.data.image.url);
      o.caption = this.data.image.caption;
    }
    return hasImage
        ? InteractionCardView._fullTemplate(o)
        : InteractionCardView._textOnlyTemplate(o);
  }

  /* Override */
  onFirstShow() { 

    // TODO: not ideal. don't understand why can't set private var in makeContent()...
    const hasImage = (this.data.image && this.data.image.url && this.data.image.caption);

    if (hasImage) {
      super.onFirstShow();
    } else {
      Autoshrink.go(this.$el.find(".text-only"), this.$el.find(".text-only .inner"))
    }
  }
}
